import React from "react";

export default function SexualHarassment(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        What constitutes Sexual Harassment?
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            For the purposes of this Policy, sexual harassment includes any one
            or more of the following unwelcome acts or behaviour, whether
            directly or by implication, committed in person, on print, or via
            computer, phone, or any other media:
          </span>

          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                physical contact and advances;
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                a demand or request for sexual favours;
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                making obscene/ sexually coloured remarks
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">showing pornography</span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                any other unwelcome physical, verbal or non-verbal conduct of a
                sexual nature. (Including, inter-alia, unpleasant or suggestive
                remarks/ actions/ gestures/ expressions, personal comments,
                jokes causing embarrassment, innuendos and taunts, sexist
                remarks, offensive telephone calls/ messages etc.)
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Further, occurrence of any of the following circumstances in
            relation to any sexually determined act or behaviour amounts to
            sexual harassment:
          </span>

          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Implied or explicit promise of preferential treatment in the
                person’s employment;
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Implied or explicit threat of detrimental treatment in person’s
                employment
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Implied or explicit threat about the person’s present or future
                employment status;
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Interference with the person’s work or creating an intimidating
                or offensive or hostile work environment for the person; or{" "}
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Humiliating treatment likely to affect the person’s health or
                safety.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Repeatedly asking to socialize during off-duty hours or
                continued expressions of sexual/ romantic interest against a
                person’s wishes;{" "}
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Deprecatory comments, conduct or any such behaviour based on the
                gender identity or sexual orientation of a person;{" "}
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">Voyeurism; or </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">Stalking; </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            If in pursuit of a legitimate professional objective or in the
            ordinary course of work, it is necessary to carry out any activity,
            including discussion, viewing, reading or other handling of issues
            or material related to sex, sexuality, pornography or other
            activities of a sexual nature, such activity will not amount to
            sexual harassment provided that care is taken to ensure that such
            activity is carried out in a professional, respectful and dignified
            manner.
          </span>
        </div>
      </div>
    </div>
  );
}
